import { LstTypeBase } from '../base/cls-lst-type-base'
import { makeObservable } from 'mobx'
/**
 * Platform class represents a single platform entity.
 * It holds all platform properties as provided by the backend.
 *
 * @class Platform
 * @param {Object} data - Initial platform data.
 * @param {string} data.id - Unique identifier for the platform.
 * @param {string} data.name - Human-readable name of the platform.
 * @param {string} [data.status] - Status of the platform (e.g., 'active', 'inactive').
 * @param {Object} [data.meta] - Any additional metadata for the platform.
 */
export class Platform {
	constructor(data) {
		// Initialize Platform properties from data
		Object.assign(this, data)
	}
}

export class Platforms extends LstTypeBase {
	constructor(list = []) {
		// Pass the Platform class and list to the parent class constructor
		super(Platform, list)

		makeObservable(this, {
			// Add properties here if Platforms has specific properties
		})
	}
}
